export const QuoterManagementPath = '/quoter-management';
export const UnauthorizedPath = '/unauthorized';
